import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-4xl font-display text-foreground-950">
              平台优势
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-500">
              为什么百万瓜友选择吃瓜爆料
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {features.map((item) => (
              <div
                key={item.id}
                className="flex flex-col items-center text-center p-5 md:p-6 rounded-lg border border-background-200/70 bg-background-50 hover:border-primary-200 transition-colors duration-300"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-xl md:text-2xl text-primary-500 w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-base md:text-lg font-display text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}